export default __webpack_public_path__ + "static/media/FKGroteskNeue-Bold.7c357486.woff2";